import Header from "components/Header"
import Footer from "components/Footer"

interface Props {
  children: React.ReactNode
}

const Page = ({ children }: Props) => {
  return (
    <div className="min-h-screen flex flex-col bg-gallery-bg">
      <Header />
      <main className="flex-1">
        <div className="gallery-container py-10 md:py-16">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Page
